import {Grid, styled} from "@mui/material";

export const SidebarPageContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: 'flex-start',
    gap: '1rem',
    paddingTop: '40px',
    marginBottom: '125px',
}));

export const SidebarPageTitleContainer = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    alignItems: 'center',
    gap: '1rem'
}));

export const SidebarPageContentContainer = styled(Grid)(() => ({
    padding: '1rem'
}));
